/** Sinyal ekrani yardimcilari - saf fonksiyonlar (signal.test.ts). */

/**
 * Gelen tarama yaniti hala ekranda secili zaman dilimine mi ait?
 *
 * Isinma dakikalar surebilir: 15M istegi 4H secildikten SONRA donerse
 * 15M satirlari 4H ekranina yazilmamalidir.
 */
export function belongsToSelection(
  requested: string,
  selected: string,
  payloadTimeframe: string,
): boolean {
  return requested === selected && payloadTimeframe === selected;
}

/** Sinyalden bu yana degisim - canli fiyat varsa ONU kullanir (her 5 sn'de
 *  tazelenir), yoksa son kapanmis mumun degerine duser. */
export function sinceSignalPct(row: {
  change_since_pct: number;
  live_change_pct?: number | null;
}): number {
  return row.live_change_pct ?? row.change_since_pct;
}

/** Guncel fiyat - canli varsa canli, yoksa son kapanmis mum. */
export function currentPrice(row: { price: number; live_price?: number | null }): number {
  return row.live_price ?? row.price;
}
